import { useNotificationApi } from './useNotificationApi';

export const useNotificationMessages = () => {
  const notificationApi = useNotificationApi();
  const handleError = (error: any) => {
    if (error?.data?.success === false) {
      Object.values(error.data.data).forEach((message) =>
        notificationApi({ type: 'error', message: message as string })
      );
    } else {
      notificationApi({ type: 'error', message: 'Something went wrong!' });
    }
  };
  const handleSuccess = (message: string) => {
    notificationApi({ type: 'success', message: message });
  };
  const handleWarning = (message: string) => {
    notificationApi({ type: 'warning', message: message });
  };

  return {
    handleError,
    handleSuccess,
    handleWarning,
  };
};
